import _concat from "lodash/concat";
import ahj from "./ahj";

export default {
  path: "/ahj",
  component: () => import("@/layouts/FullLayout"),
  children: _concat(ahj)
};
